import { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { ISwitcherProps } from 'components/uiKit/Switcher/Switcher'
import Switcher from 'components/uiKit/Switcher/Switcher'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldSwitcher: React.FC<IControlProps<ISwitcherProps>> = ({
  name,
  onChange,
  defaultValue,
  value,
  ...rest
}) => {
  const handleChange = useCallback((value: boolean) => onChange({ value, name }), [name, onChange])
  return (
    <Switcher
      name={name}
      onChange={handleChange}
      value={value ?? (defaultValue as boolean)}
      {...rest}
    />
  )
}

export default FieldSwitcher
